import React, { useState } from 'react';
import { DatePicker, Select } from 'antd';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/bn_BD';
import 'antd/dist/antd.css';
const ContemptCaseForm = () => {
    const [formData, setFormData] = useState({
        contemptCaseNumber: '',
        contemptCaseReason: '',
        contemptCaseJudgment: '',
        contemptDetails: '',
        documents: [{ name: '', file: null }]
    });

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };
    const handleDateChange = (field, date) => {
        if (date && moment.isMoment(date) && date.isValid()) {
            handleInputChange(field, date.format('YYYY-MM-DD'));
        } else if (date === null) {
            handleInputChange(field, '');
        } else {
            console.warn('Invalid date selected:', date);
            handleInputChange(field, '');
        }
    };

    const getSafeDateValue = (dateString) => {
        if (!dateString) return null;
        return dayjs(dateString, 'YYYY-MM-DD').isValid() ? dayjs(dateString, 'YYYY-MM-DD') : null;
    };

    const addDocument = () => {
        setFormData(prev => ({
            ...prev,
            documents: [...prev.documents, { name: '', file: null }]
        }));
    };

    const removeDocument = (index) => {
        if (formData.documents.length > 1) {
            setFormData(prev => ({
                ...prev,
                documents: prev.documents.filter((_, i) => i !== index)
            }));
        }
    };

    const updateDocument = (index, field, value) => {
        const updatedDocs = [...formData.documents];
        updatedDocs[index] = { ...updatedDocs[index], [field]: value };
        setFormData(prev => ({
            ...prev,
            documents: updatedDocs
        }));
    };

    const styles = {
        formInput: {
            width: '100%',
            padding: '10px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            fontSize: '14px',
            backgroundColor: 'white'
        },
        textarea: {
            width: '100%',
            padding: '10px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            fontSize: '14px',
            resize: 'vertical',
            backgroundColor: 'white',
            minHeight: '120px'
        },
        label: {
            display: 'block',
            fontSize: '14px',
            fontWeight: '500',
            marginBottom: '8px',
            color: '#374151'
        },
        datePicker: {
            width: '100%',
            height: '36px'
        },
        uploadSection: {
            backgroundColor: '#a7f3d0',
            border: '1px solid #6ee7b7',
            padding: '16px',
            marginBottom: '20px',
            borderRadius: '4px'
        },
        uploadHeader: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#065f46',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        uploadHeaderText: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
        },
        addButton: {
            width: '32px',
            height: '32px',
            backgroundColor: '#059669',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        removeButton: {
            width: '32px',
            height: '32px',
            backgroundColor: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        browseButton: {
            padding: '8px 16px',
            backgroundColor: '#6b7280',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        submitButton: {
            padding: '12px 32px',
            backgroundColor: '#0d9488',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            fontSize: '16px'
        },
        documentRow: {
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '12px',
            backgroundColor: 'white',
            padding: '8px',
            borderRadius: '4px',
            border: '1px solid #d1d5db'
        },
        fileLabel: {
            fontSize: '14px',
            color: '#4b5563',
            minWidth: '120px'
        },
        modal: {
            position: 'fixed',
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
        },
        modalContent: {
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            textAlign: 'center',
            maxWidth: '400px',
            width: '90%'
        },
        modalIcon: {
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            backgroundColor: '#fed7aa',
            border: '3px solid #fb923c',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            fontSize: '24px',
            color: '#ea580c'
        },
        modalTitle: {
            fontSize: '18px',
            fontWeight: '600',
            marginBottom: '16px',
            color: '#374151'
        },
        modalText: {
            fontSize: '14px',
            color: '#6b7280',
            marginBottom: '24px',
            lineHeight: '1.5'
        },
        modalButtons: {
            display: 'flex',
            gap: '12px',
            justifyContent: 'center'
        },
        modalButtonYes: {
            padding: '10px 20px',
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        modalButtonNo: {
            padding: '10px 20px',
            backgroundColor: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        radioGroup: {
            display: 'flex',
            gap: '24px',
            marginTop: '8px'
        },
        radioOption: {
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px'
        }
    };

    return (
        <div style={{ backgroundColor: '#f8f9fa', textAlign: "left", minHeight: '100vh' }}>
            <div style={{ maxWidth: '1000px', margin: '0 auto', backgroundColor: 'white', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>

                {/* Three Column Input Section */}
                <div className="row mb-4">
                    <div className="col-md-4">
                        <label style={styles.label}>
                            প্রযোজ্য ক্ষেত্রে কন্টেম্পট মামলা নম্বর
                        </label>
                        <input
                            type="text"
                            style={styles.formInput}
                            value={formData.contemptCaseNumber}
                            onChange={(e) => handleInputChange('contemptCaseNumber', e.target.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <label style={styles.label}>
                            কন্টেম্পট মামলা রুল ইস্যুর তারিখ
                        </label>

                        <DatePicker
                            style={styles.datePicker}
                            placeholder="দিন/মাস/বছর"
                            value={getSafeDateValue(formData.contemptCaseReason)}
                            onChange={(date) => handleDateChange('contemptCaseReason', date)}
                            format="DD/MM/YYYY"
                            locale={locale}
                            allowClear={true}
                            inputReadOnly={false}
                            showToday={true}
                            showTime={false}
                            status={formData.contemptCaseReason && !getSafeDateValue(formData.contemptCaseReason) ? 'error' : ''}
                            onBlur={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue) {
                                    const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                    if (parsedDate.isValid()) {
                                        handleDateChange('contemptCaseReason', parsedDate);
                                    }
                                }
                            }}
                        />
                    </div>
                    <div className="col-md-4">
                        <label style={styles.label}>
                            কন্টেম্পট মামলার জবাব প্রেরণের তারিখ
                        </label>


                        <DatePicker
                            style={styles.datePicker}
                            placeholder="দিন/মাস/বছর"
                            value={getSafeDateValue(formData.contemptCaseJudgment)}
                            onChange={(date) => handleDateChange('contemptCaseJudgment', date)}
                            format="DD/MM/YYYY"
                            locale={locale}
                            allowClear={true}
                            inputReadOnly={false}
                            showToday={true}
                            showTime={false}
                            status={formData.contemptCaseJudgment && !getSafeDateValue(formData.contemptCaseJudgment) ? 'error' : ''}
                            onBlur={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue) {
                                    const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                    if (parsedDate.isValid()) {
                                        handleDateChange('contemptCaseJudgment', parsedDate);
                                    }
                                }
                            }}
                        />
                    </div>
                </div>

                {/* Case Details Section */}
                <div style={{ marginBottom: '24px' }}>
                    <label style={styles.label}>
                        অন্যান্য পদক্ষেপের বিবরণ
                        <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: 'normal' }}>
                            {' '}(যদি থাকে)
                        </span>
                    </label>
                    <textarea
                        style={styles.textarea}
                        value={formData.contemptDetails}
                        onChange={(e) => handleInputChange('contemptDetails', e.target.value)}
                    />
                </div>

                {/* Document Upload Section */}
                <div style={styles.uploadSection}>
                    <div style={styles.uploadHeader}>
                        <div style={styles.uploadHeaderText}>
                            <span>সংযুক্তি (কনটেম্প্ট মামলা সম্পর্কিত কপি সংযুক্ত করুন) </span>
                            <span style={{ color: '#dc2626' }}>*</span>
                            <span style={{ fontSize: '12px', color: '#dc2626', fontWeight: 'normal' }}>
                                {' '}(PDF, সর্বোচ্চ সাইজ : 5MB)
                            </span>
                        </div>
                        <button
                            type="button"
                            onClick={addDocument}
                            style={styles.addButton}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#047857'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#059669'}
                        >
                            <i className="fas fa-plus" style={{ fontSize: '14px' }}></i>
                        </button>
                    </div>

                    {formData.documents.map((doc, index) => (
                        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>

                            {/* Document Name */}
                            <input
                                type="text"
                                // placeholder="ডকুমেন্টের নাম"
                                value={doc.name}
                                onChange={(e) => {
                                    const updatedDocs = [...formData.documents];
                                    updatedDocs[index].name = e.target.value;
                                    setFormData({ ...formData, documents: updatedDocs });
                                }}
                                style={{ ...styles.formInput, flex: '1', width: "30%" }}
                            />

                            {/* File Upload */}
                            <input
                                type="file"
                                accept=".pdf,.doc,.docx"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    const updatedDocs = [...formData.documents];
                                    updatedDocs[index].file = file;
                                    setFormData({ ...formData, documents: updatedDocs });
                                }}
                                style={{ flex: '1', width: "40%", backgroundColor: '#f3f4f6', border: '1px solid #cbd5e1', borderRadius: '4px', padding: '8px' }}
                            />

                            {/* Remove Button */}
                            <button
                                type="button"
                                onClick={() => removeDocument(index)}
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    backgroundColor: '#ef4444',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#dc2626'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#ef4444'}
                            >
                                <i className="fas fa-minus" style={{ fontSize: '12px' }}></i>
                            </button>
                        </div>
                    ))}
                </div>

                {/* Submit Button */}
                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                    <button
                        type="submit"
                        style={styles.submitButton}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#0f766e'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#0d9488'}
                    >
                        সংরক্ষণ
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ContemptCaseForm;